export const DEP_TYPE = {
  SFY: 1,
  KNXHNK: 2,
  DYT: 3,
  ZNDJ: 4,
}

/**
 * depType 策略注册表（策略模式）。
 *
 * 每个业务线一条策略，集中声明该业务线的差异化配置；
 * 新增 depType 时只需在 DEP_TYPE 中加常量、在此追加一条策略即可，
 * 所有消费方（guidance.vue / store 等）通过 getDepTypeStrategy() 取配置，
 * 无需散落 if/else 判断，互不冲突。
 */
const DEP_TYPE_STRATEGIES = {
  [DEP_TYPE.SFY]: {
    label: '昆明市妇幼保健院',
    dictType: 'zndz_prompts_kmsfy',
    code: 'sfy',
    composerPlaceholder: '输入症状或挂号需求',
  },
  [DEP_TYPE.KNXHNK]: {
    label: '昆华消化内科',
    dictType: 'zndz_prompts_knxhnk',
    code: 'knxhnk',
    composerPlaceholder: '输入症状或挂号需求',
  },
  [DEP_TYPE.DYT]: {
    label: '滇医通',
    dictType: 'zndz_prompts_dyt',
    code: 'dyt',
    composerPlaceholder: '输入症状或挂号需求',
  },
  [DEP_TYPE.ZNDJ]: {
    label: '智能导检',
    dictType: 'zndz_prompts_zndj',
    code: 'zndj',
    composerPlaceholder: '请输入您的需求',
  },
}

export const DEFAULT_DEP_TYPE = DEP_TYPE.SFY
const DEFAULT_COMPOSER_PLACEHOLDER = '输入症状或挂号需求'

export function normalizeDepType(value) {
  const num = Number(value)
  return DEP_TYPE_STRATEGIES[num] ? num : DEFAULT_DEP_TYPE
}

export function getDepTypeStrategy(value) {
  return DEP_TYPE_STRATEGIES[normalizeDepType(value)]
}

// ---- 以下为兼容既有调用方的便捷 API，均委托给策略表 ----

export function getDepTypeInfo(value) {
  return getDepTypeStrategy(value)
}

export function getDepTypeLabel(value) {
  return getDepTypeStrategy(value).label
}

export function getDepTypeDictType(value) {
  return getDepTypeStrategy(value).dictType
}

export function getDepTypeComposerPlaceholder(value) {
  return getDepTypeStrategy(value).composerPlaceholder || DEFAULT_COMPOSER_PLACEHOLDER
}
